import create from '../creator'
import axios from '@/wrapper'

const initialState = () => ({
  consent: {
    message: '',
  },
})
const _state = initialState()

const actions = {
  async fetchConsentMessage({ commit }) {
    const resp = await axios.get(`v30/consentMessage/getConsentMessage`)
    commit('setMessage', resp.data.message)

    return resp
  },
}

const mutations = {
  setMessage(state, message) {
    state.consent.message = message
  },
}

export default create(
  {
    namespaced: true,
    state: _state,
    actions,
    mutations,
  },
  initialState()
)
